import { RecommendationCompanyMetadata } from './recommendationCompanyModel';

export function isRecommendationMetadata(
    metadata: Record<string, any>
): metadata is RecommendationCompanyMetadata {
    return (metadata as RecommendationCompanyMetadata).recommended instanceof Set;
}
